module.exports = __webpack_public_path__ + "static/image/history/pc/202308@x3.jpg?78ac6648";